export interface ProjectMenuCallbacks {
  onToggle: (projectId: string, container: HTMLElement) => void;
  onRename: () => void;
  onDelete: () => void;
}

export const createProjectMenu = (
  projectId: string,
  callbacks: ProjectMenuCallbacks
): HTMLDivElement => {
  const menuContainer = document.createElement('div');
  menuContainer.className = 'project-menu';

  const menuBtn = document.createElement('button');
  menuBtn.className = 'menu-btn';
  menuBtn.innerHTML = `
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <circle cx="12" cy="5" r="2"/>
      <circle cx="12" cy="12" r="2"/>
      <circle cx="12" cy="19" r="2"/>
    </svg>
  `;
  menuBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    callbacks.onToggle(projectId, menuContainer);
  });

  const dropdown = document.createElement('div');
  dropdown.className = 'menu-dropdown';
  dropdown.id = `menu-${projectId}`;

  const renameOption = document.createElement('button');
  renameOption.className = 'menu-option';
  renameOption.innerHTML = `
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
    </svg>
    Rename
  `;
  renameOption.addEventListener('click', (e) => {
    e.stopPropagation();
    callbacks.onRename();
  });

  const deleteOption = document.createElement('button');
  deleteOption.className = 'menu-option delete';
  deleteOption.innerHTML = `
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <polyline points="3 6 5 6 21 6"/>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
    </svg>
    Delete
  `;
  deleteOption.addEventListener('click', (e) => {
    e.stopPropagation();
    callbacks.onDelete();
  });

  dropdown.appendChild(renameOption);
  dropdown.appendChild(deleteOption);
  menuContainer.appendChild(menuBtn);
  menuContainer.appendChild(dropdown);

  return menuContainer;
};
